import sp6 from "../../assets/safety-products/sp-6.png";
import sp7 from "../../assets/safety-products/sp-7.png";
import sp8 from "../../assets/safety-products/sp-8.png";
import sp9 from "../../assets/safety-products/sp-9.png";
import sp10 from "../../assets/safety-products/sp-10.png";
import sp11 from "../../assets/safety-products/sp-11.png";
import sp12 from "../../assets/safety-products/sp-12.png";
import sp13 from "../../assets/safety-products/sp-13.png";
import sp14 from "../../assets/safety-products/sp-14.png";
import sp15 from "../../assets/safety-products/sp-15.png";
import sp16 from "../../assets/safety-products/sp-16.png";
import sp17 from "../../assets/safety-products/sp-17.png";
import sp18 from "../../assets/safety-products/sp-18.png";
import sp19 from "../../assets/safety-products/sp-19.png";
import sp20 from "../../assets/safety-products/sp-20.png";
import sp21 from "../../assets/safety-products/sp-21.png";
import sp22 from "../../assets/safety-products/sp-22.png";
import sp23 from "../../assets/safety-products/sp-23.png";
import sp24 from "../../assets/safety-products/sp-24.png";
import sp25 from "../../assets/safety-products/sp-25.png";
import sp26 from "../../assets/safety-products/sp-26.png";

export const dataHeadProtection = [
  {
    title: "Head Protection",
    productDescription:
      " Industrial Safety Helmets and Bumpcaps of renowned brands (Honeywell, Karam, Windsor, Guards etc.) are available with-",
    points: [
      "  Ventilated & Non Ventilated  Shells",
      "Nape Type & Ratchet Type Head Bands",
      "  ISI, EN & ANSI approvals",
      "  We also provide helmets with your logo",
    ],
  },
];
export const imagesHeadProtection = [{ image: sp6 }];
export const imagesHearingProtection = [{ image: sp7 }];
export const dataHearingProtection = [
  {
    title: "Hearing  Protection",
    productDescription:
      "  An extensive range of Disposable & Reusable (Corded / Uncorded) Ear Plugs, Banded Ear Plugs,Ear Muffs, Ear Plug Dispensers confirming to standards laid down by EN 352",
    points: [
      "  Disposable Foam Ear Plugs - Corded / Uncorded",
      "  Reusable Silicone Ear Plugs - Corded / Uncorded",
      "  Banded Ear Plugs",
      "  Ear Muffs",
      "  Ear Plug Dispensers",
    ],
  },
];
export const imagesEyeProtection = [{ image: sp8 }, { image: sp9 }];
export const dataEyeProtection = [
  {
    title: "Eye Protection & Accessories",
    productDescription:
      " A Complete range of Safety Spectacles & Goggles (with Polycarbonate / Acetate Lens having Antifog,  Antiscratch, Anti UV, Antistatic properties) of KARAM & Honeywell make to suit a variety of applications, from general industry  to specilized welding jobs & chemical handling. \n Our range of safety spectacles are CE Certified & confirm to the standards as laid down in EN 166:2001.\nLens Options:\n➤ Clear\n➤ Smoke / Grey\n➤ Amber\n➤ IR 11 / IR 5 / IR 3\n➤ Indoor/Outdoor",
  },
];
export const dataFaceProtection = [
  {
    title: "Face  Protection",
    productDescription:
      "An Exclusive range of Face protectors & Welding Shields designed to protect wearer's eyes & face from the harmful radiations including visible light , UV/IR radiations resulting from certain processes. A wide range of face shields suitable for - Metal cutting operation, Spray Painting, Petroleum IndustryChemical Industry, Grinding, Processing, Electrical- Gas Welding & Iron and Steel industry.  \nVisor Options:\n➤ Clear\n➤ Smoke Grey\n➤ IR Shade 5 / Shade 8\n➤ Wire Mesh \n➤ Hi-Temp Gold Coated",
  },
];
export const imagesFaceProtection = [{ image: sp10 }];

export const dataRespiratoryProtection = [
  {
    title: "Respiratory  Protection",
    productDescription:
      " A full range of Respiratory Protective Equipments like Disposable Respirators, Reusable Half Face & Full Face Respirators, Escape Masks, Powered Air Purifying Respirators (PAPR), Supplied Air Respirators & Self Contained Breathing Apparatus (SCBA)",
  },
];
export const imagesRespiratoryProtection = [{ image: sp11 }];
export const dataHandProtection = [
  {
    title: "Hand  Protection",
    productDescription:
      "A Complete range of EN approved Industrial Safety Hand Gloves of Honeywell & KARAM Brand ",
  },
];
export const imagesHandProtection = [{ image: sp12 }, { image: sp13 }];
export const dataProtectiveClothing = [
  {
    title: "Protective  Clothing",
    productDescription:
      "A complete range of Protective clothing - Disposable Coveralls for  Chemical, Pharmaceutical, Petrochemical Industries, Aluminised Proximity Suits, Nomex Fire Suits,  Welding Aprons, Sleeves, PVC Suits. ",
  },
];
export const imagesProtectiveClothing = [{ image: sp14 }];
export const dataFeetProtection = [
  {
    title: "Feet  Protection",
    productDescription:
      " An extensive range of Industrial Safety Footwears with Steel / Composite Toe, Direct Injected Single / Double Density PU/PU + TPU Sole, Single/Triple Density PVC Sole. PVC Gumboots with Steel Toe . Confirming to standards laid down by IS 15298 & EN ISO 20345.",
  },
];
export const imagesFeetProtection = [{ image: sp15 }];
export const dataFallProtection = [
  {
    title: "Fall  Protection",
    productDescription:
      " An extensive range of Full Body Harnesses, Rope Grab & Retractable Fall Arresters, Descenders, Tripod- Winch, Anchorage Lines & Hooks, Work Positioning Belts & Lanyards,  Horizontal Life Lines, Variety of fall protection & Rescue kits, Fixed Line System (Permanent Anchorage Lines) (CE marked & Conforming to EN 361, EN 353, EN 358, EN 813, EN 360.) ",
  },
];
export const imagesFallProtection = [{ image: sp16 }];
export const dataTrafficSafety = [
  {
    title: "Traffic  Safety & Signages",
    productDescription:
      "  Customised Safety Signages, Autoglow Signages & Barrication (Caution) Tapes, All types of Traffic Safety Equipments, Traffic Cones, Convex Mirrors, Batons, Speed bumps, Floor Signages, Floor Marking Tapes etc ",
  },
];
export const imagesTrafficSafety = [{ image: sp17 }];
export const dataDetectors = [
  {
    title: "Portable Gas Detectors",
    productDescription:
      "   A complete range of Honeywell make Portable Gas Detectors, Online Gas Detectors (Fixed Type). We also provide calibration & maintenance service for Honeywell Make gas detectors",
  },
];
export const imagesDetectors= [{ image: sp18 }];
export const dataLOTOEquipments = [
  {
    title: " LOTO Equipments (Lock Out Tag Out)",
    productDescription:
      "   Hasp, Padlock, Cylinder Lockout, Cable Lockout, Valve Lockout, Circuit Breaker Lockout, Electrical Lockout, Safety Lockout Tags, LOTO Station and LOTO Kits",
  },
];
export const imagesLOTOEquipments= [{ image: sp19 }];
export const dataGeneralSafety = [
  {
    title: " General Safety Products",
  }
   
];
export const imagesGeneralSafety = [{ image: sp20 }];
export const dataFireExtinguishers = [
  {
    title: " Fire Extinguishers & Hydrants Accessories",
    productDescription:"A complete range of Minimax Brand Fire Extinguishers. Hydrant Valve, Hose Box, Hose Reel Drum, Branch Pipe, Fire Hose & Coupling, delivery Hose Coupling, Fire Blanket, Fire Bucket, Fireman Axe.",
  }
   
];
export const imagesFireExtinguishers = [{ image: sp21 }, { image: sp22 }, { image: sp23 }];
export const dataSpillKits = [
  {
    title: " Spill Kits",
  }
   
];
export const imagesSpillKits = [{ image: sp24 }];
export const dataFireElectricalArcProtection = [
  {
    title: " Electrical Arc Protection",
    productDescription:" The NFPA 70E Standard and OSHA Regulations have been established to protect workers from electrical shock and arc flash hazards. We have complete range of Salisbury by Honeywell brand products, to meet the NFPA 70E Standard and OSHA 29 1910.269 Regulations. Only Salisbury can provide the complete list of Personal Protective Equipment required to protect workers against electrical hazards as defined by OSHA Regulations and the NFPA 70E Standard for Electrical Safety in the Workplace. We do undertake - Electrical Safety Program Assessment, Onsite Electrical Safety Training.",
  }
   
];
export const imagesElectricalArcProtection = [{ image: sp25 }, { image: sp26 }, ];

export const safetyProductsConstant = {
  dataHeadProtection: dataHeadProtection,
  imagesHeadProtection: imagesHeadProtection,
  imagesHearingProtection: imagesHearingProtection,
  dataHearingProtection: dataHearingProtection,
  imagesEyeProtection: imagesEyeProtection,
  dataEyeProtection: dataEyeProtection,
  dataFaceProtection: dataFaceProtection,
  imagesFaceProtection: imagesFaceProtection,
  dataRespiratoryProtection: dataRespiratoryProtection,
  imagesRespiratoryProtection: imagesRespiratoryProtection,
  dataHandProtection: dataHandProtection,
  imagesHandProtection: imagesHandProtection,
  dataProtectiveClothing: dataProtectiveClothing,
  imagesProtectiveClothing: imagesProtectiveClothing,
  dataFeetProtection: dataFeetProtection,
  imagesFeetProtection: imagesFeetProtection,
  dataFallProtection: dataFallProtection,
  imagesFallProtection: imagesFallProtection,
  dataTrafficSafety: dataTrafficSafety,
  imagesTrafficSafety: imagesTrafficSafety,
    dataDetectors: dataDetectors,
    imagesDetectors: imagesDetectors,
    dataLOTOEquipments: dataLOTOEquipments,
    imagesLOTOEquipments: imagesLOTOEquipments,
    dataGeneralSafety: dataGeneralSafety,
    imagesGeneralSafety: imagesGeneralSafety,
    dataFireExtinguishers: dataFireExtinguishers,
    imagesFireExtinguishers: imagesFireExtinguishers,
    dataSpillKits: dataSpillKits,
    imagesSpillKits: imagesSpillKits,
    dataFireElectricalArcProtection: dataFireElectricalArcProtection,
    imagesElectricalArcProtection: imagesElectricalArcProtection,
};
